import { css } from "@emotion/core";
import { fontSizes, fonts, color } from "../../../theme/Theme";

export const accountDetailsCardStyles = css({
  ".anticon": {
    fontSize: fontSizes.disbursalIcons
  },
  ".detail-key": {
    fontSize: fontSizes.label
  },
  ".detail-value": {
    fontFamily: fonts.bold
  },
  ".instruction-text": {
    color: color.darkGrey
  }
});
